module.exports = __webpack_public_path__ + "img/thumbnail_NileMonitor_m_albino.23480644.png";